import { render } from "./SuccessfulModal.vue?vue&type=template&id=4d9a48f4&scoped=true"
import script from "./SuccessfulModal.vue?vue&type=script&lang=js"
export * from "./SuccessfulModal.vue?vue&type=script&lang=js"

import "./SuccessfulModal.vue?vue&type=style&index=0&id=4d9a48f4&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9a48f4"]])

export default __exports__